var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Sidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 4.89543 3.89543 4 5 4C6.10457 4 7 4.89543 7 6V18C7 19.1046 6.10457 20 5 20C3.89543 20 3 19.1046 3 18V6Z",
    fill: "#A4ACB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6C8.5 4.89543 9.39543 4 10.5 4H19C20.1046 4 21 4.89543 21 6V18C21 19.1046 20.1046 20 19 20L10.5 20C9.39543 20 8.5 19.1046 8.5 18V6Z",
    fill: "#A4ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Sidebar);
export default __webpack_public_path__ + "static/media/24_Sidebar.21f95b99356ebe89bffff95fb0a5202f.svg";
export { ForwardRef as ReactComponent };